import { useIntl } from 'gatsby-plugin-intl';
import * as React from 'react';

import { Layout } from '../components/common/Layout';
import { SEO } from '../components/common/Seo';
import { ContactUsInfo } from '../components/pages-chunks/home/ContactUsInfo';
import { Dashboard } from '../components/pages-chunks/home/Dashboard';
import { Lead } from '../components/pages-chunks/home/Lead';
import { PartnerInfo } from '../components/pages-chunks/home/PartnerInfo';
import { ToolsAndPaymentsSystems } from '../components/pages-chunks/home/ToolsAndPaymentsSystems';

const IndexPage = () => {
  const intl = useIntl();

  return (
    <Layout absoluteHeader>
      <SEO title={intl.formatMessage({ id: 'seo.homepage.title' })} />
      <Lead />
      <PartnerInfo />
      <Dashboard />
      <ToolsAndPaymentsSystems />
      <ContactUsInfo />
    </Layout>
  );
};

export default IndexPage;
